import { render, staticRenderFns } from "./CategoryMain.vue?vue&type=template&id=9d013d46&"
import script from "./CategoryMain.vue?vue&type=script&lang=js&"
export * from "./CategoryMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports